import React from 'react'
import logo from "../components/images/logo.png";
import { Link,NavLink } from "react-router-dom";

export default function Sidebar() {
      
    const closeNav = () => {
        document.getElementById("mySidebar").style.width = "0";
        document.getElementById("main").style.marginLeft= "0";
    };
    const openNav = () => {
      document.getElementById("mySidebar").style.width = "250px";
      document.getElementById("main").style.marginLeft = "0px";
    };

    let data = [
        { icon: "grid_view", list: "Dashboard", uri: "/" },
        { icon: "admin_panel_settings", list: "Consult", uri: "/Consult" },
        { icon: "health_and_safety", list: "Health", uri: "/Health" },
        { icon: "history_edu", list: "History", uri: "/History" },
        { icon: "notifications", list: "Notifications", uri: "/Notification" },
        { icon: "today", list: "Reminders", uri: "/Reminder" },
        { icon: "medical_services", list: "Medicine", uri: "/Preventive",
        },
    ];

    
  return (
    <div>
      <div id="mySidebar" class="sidebar">
          <div className="logo"><img src={logo}/></div>
          <a href="javascript:void(0)" class="closebtn" onClick={() => {closeNav();}}>×</a>
          <div className="sidebar_inner">
            {data.map((items, index) => (
              <ul key={index} className="vertical-nav-menu">
                <li className="">
                  <NavLink to={items.uri}>
                    <i className=" list_icon material-icons">{items.icon}</i>
                    {items.list}
                  </NavLink>
                </li>
              </ul>
            ))}
          </div>
      </div>
      <div id="main" className='main'>
          <button class="openbtn" onClick={() => {openNav();}}><i className="material-icons">menu</i></button> 
          <div className="logo_mobile"><img src={logo}/></div> 
      </div>
      
    </div>
  )
}
